import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {FuseConfirmDialogComponent} from '../../../@fuse/components/confirm-dialog/confirm-dialog.component';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  private currentDialogRef: MatDialogRef<any>;

  constructor(private matDialog: MatDialog) {
  }

  showConfirmationDialog(title: string = 'Confirm', message: string = 'Are you sure?'): Observable<boolean> {
    if (this.currentDialogRef == null) {
      this.currentDialogRef = this.matDialog.open(FuseConfirmDialogComponent, {
        disableClose: true
      });

      this.currentDialogRef.componentInstance.confirmMessage = message;
      this.currentDialogRef.componentInstance.confirmTitle = title;
    }

    return this.currentDialogRef.afterClosed().pipe(
      tap(() => {
        setTimeout(() => {
          this.currentDialogRef = null;
        }, 500);
      })
    );
  }
}
